import { CircularProgress } from '@material-ui/core';
import * as React from 'react';

interface LoadingProps {
    size?: number;
    thickness?: number;
}

const DEFAULT_LOADING_SIZE = 40;
const DEFAULT_LOADING_THICKNESS = 3;

const Loading: React.FC<LoadingProps> = ({ size = DEFAULT_LOADING_SIZE, thickness = DEFAULT_LOADING_THICKNESS }) => {
    const loadingStyle: React.CSSProperties = {
        left: '50%',
        marginLeft: `${-size / 2}px`, // tslint:disable-line:no-magic-numbers
        marginTop: `${-size}px`,
        position: 'absolute' as 'absolute',
        top: '50%'
    };
    return <CircularProgress size={size} style={loadingStyle} thickness={thickness} />;
};

export { Loading };
